export * from "./intro-image";
